import { Playground } from 'docz';
import { Inline, Icon, addIcon, svgIconResolver } from 'react-nails';
import { ReactComponent as NailsLogo } from "..\\..\\..\\..\\..\\docz\\Icon\\react-nails-logo.svg";
import React from 'react';
export default {
  Playground,
  Inline,
  Icon,
  addIcon,
  svgIconResolver,
  NailsLogo,
  React
};